export var DataCatalogTagResourceType;
(function (DataCatalogTagResourceType) {
    DataCatalogTagResourceType["DATA_CATALOG_TAG_RESOURCE_TYPE_CATALOG"] = "CATALOG";
    DataCatalogTagResourceType["DATA_CATALOG_TAG_RESOURCE_TYPE_NAMESPACE"] = "NAMESPACE";
    DataCatalogTagResourceType["DATA_CATALOG_TAG_RESOURCE_TYPE_DATASET"] = "DATASET";
    DataCatalogTagResourceType["DATA_CATALOG_TAG_RESOURCE_TYPE_COLUMN"] = "COLUMN";
})(DataCatalogTagResourceType || (DataCatalogTagResourceType = {}));
